'use strict';

module.exports = {
  template: require('./button-spinner.html'),
  controller: require('./button-spinner.controller'),
  controllerAs: 'vm',

  bindings: {
    active: '<',
    type: '@',
    buttonClass: '@',
    disabled: '<',
    spanClass: '@',
    stateActiveIcon: '@',
    stateActiveText: '<',
    stateNormalIcon: '@',
    stateNormalText: '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/button-spinner/index.js
 ** module id = 42
 ** module chunks = 0
 **/